import {
    Directive, OnChanges, AfterViewInit, EventEmitter,
    OnInit, Output, Input, OnDestroy, ElementRef, SimpleChange
} from '@angular/core';
import { dragula, DragulaService } from 'ng2-dragula';
import { Subscription } from 'rxjs';
import * as $$ from 'jquery';
import { element } from 'protractor';

declare var jquery: any;
declare var $: any;

@Directive({ selector: 'ngx-datatable[dragulaName]' })
export class DragulaExtendedDirective implements OnChanges, OnInit, AfterViewInit, OnDestroy {
    @Input() public dragulaName: string;
    @Input() public dragulaModel: any;
    @Input() public selectedrag: any;
    @Input() public dragulaVScroll: any;
    @Input() public classSelector: String = 'null';
    @Output() public directiveDrop: EventEmitter<any> = new EventEmitter<any>();
    @Output() public directiveDrag: EventEmitter<any> = new EventEmitter<any>();
    @Output() public directiveShadow: EventEmitter<any> = new EventEmitter<any>();

    protected container: any;
    private drake: any;
    private options: any;
    private el: ElementRef;
    private dragulaService: DragulaService;
    subscriptionDrag: any = null;
    subscriptionDrop: any = null;
    subs = new Subscription();
    elementTodrag: any;

    public constructor(el: ElementRef, dragulaService: DragulaService) {
        this.el = el;
        this.dragulaService = dragulaService;
    }
    ngOnInit() {

    }

    ngAfterViewInit() {
        if (this.el) {
            const container = this.el;

            // Check for the row's parent node: datatable-scroller
            // This is what you want to bind Dragula to, in order to drag sort
            if (container.nativeElement.querySelector('datatable-scroller')) {
                const rowParent = container.nativeElement.querySelector('datatable-scroller');

                // Check if this Dragula already exists
                if (!this.dragulaService.find(this.dragulaName)) {

                    // Must assign the new rowParent as the container you want to pass to Dragula
                    this.container = rowParent;

                    if (this.dragulaName) {
                        this.initializeDragula();
                    }

                    // Check VScroll
                    if (this.dragulaVScroll) {

                    }
                }
            }
        }
    }

    ngOnDestroy() {

        // Clear this Dragula always
        // comment out if you want to keep it
        if (this.dragulaService.find(this.dragulaName)) {
            this.dragulaService.destroy(this.dragulaName);
        }

        // Clear DRAG and DROP subscription to prevent duplicates
        if (this.subscriptionDrag) {
            this.subscriptionDrag.unsubscribe();
            this.subscriptionDrag = null;
        }
        if (this.subscriptionDrop) {
            this.subscriptionDrop.unsubscribe();
            this.subscriptionDrop = null;
        }
    }

    protected initializeDragula() {
        // Create new Dragula container
        const bag = this.dragulaService.find(this.dragulaName);
        if (bag) {
            this.drake = bag.drake;
            console.log('hello 3', this.drake, bag)
            this.checkModel();
            this.drake.containers.push(this.container);
        } else {

            // Check if classSelector was specified
            // *true:
            //    - the classSelector string will be used to match the class of the element clicked
            //    - the element with the matching class name will be used to drag the row
            // *false:
            //    - no class selector will be used
            //    - the whole row will default back to being draggable
            if (this.classSelector !== 'null') {
                const classSelector = this.classSelector;
                const options = {
                    moves: function (el, container, handle) {
                        return handle.className === classSelector;
                    }
                };
                this.drake = dragula([this.container], options);
            } else {
                this.drake = dragula([this.container], {
                    moves: (el, container, handle) => {
                        console.log('hello 1', handle);
                        return handle.tagName === 'I' || handle.className === 'selecticon';
                    },
                });
                const ctrl = this;
                let indexFirst = 0;
                let elementClone;
                this.drake.on('drag', function (el, source) {
                    // oppacity on drag multiple
                    // ne pas supprimer les ligne active
                    // $('datatable-body-row.datatable-body-row.active').each(function (index) {
                    //     const elem = $(this).parent();
                    //     $(elem).hide();
                    // });
                    $(el).show();
                    elementClone = $(el).clone();
                    const elem = $(el).find('.getID');
                    console.log('hello 2', elem);
                    ctrl.elementTodrag = ctrl.dragulaModel[$(elem).attr('id')];
                    ctrl.drag(ctrl.dragulaModel[$(elem).attr('id')]);
                });

                this.drake.on('drop', function (el, target, source, sibling) {
                    ctrl.drop(el, target);
                });

                this.drake.on('shadow', function (el, target, source, sibling) {
                    const mouvFirst = $($(el).find('.getID')).attr('id');
                    const indexOf = $(source).find('datatable-row-wrapper').index(el);
                    if (ctrl.dragulaVScroll) {
                        $(source).find('datatable-row-wrapper').each(function (index) {
                            let getID = $($(this).find('.getID')).attr('id');
                            if (!index && (this !== el)) {
                                indexFirst = parseInt((getID ? (mouvFirst && getID !== '1' ? getID : '0') : '0'), 10);
                            } else {
                                if (!index && this === el) {
                                    const elemindex1 = $(source).find('datatable-row-wrapper')[1];
                                    getID = $($(elemindex1).find('.getID')).attr('id');
                                    indexFirst = parseInt((getID ? (getID !== '1' ? getID : '0') : '0'), 10);
                                }
                            }

                            if (ctrl.dragulaModel[$($(el).find('.getID')).attr('id')]) {
                                $(this).css('transform', 'translate3d(0px, ' + ((indexFirst + index) * 30) + 'px, 0px)');
                            } else {
                                if (this === el || indexOf === index) {
                                    $(this).html($(elementClone).clone());
                                    $(this).find('.getID').removeClass('getID')
                                    $(this).find('.selecticon').each(function () {
                                        $(this).html(`<i class="fa fa-arrows" aria-hidden="true"></i>`);
                                    });
                                    $(elementClone).css('transform', 'translate3d(0px, ' + ((indexFirst + index) * 30) + 'px, 0px)');
                                    $(this).css('transform', 'translate3d(0px, ' + ((indexFirst + index) * 30) + 'px, 0px)');
                                    $(this).css('z-index', '10');
                                    $(this).css('background-color', '#f9f9f9');

                                    $(el).html($(elementClone).clone());
                                    $(el).find('.getID').removeClass('getID')
                                    $(el).find('.selecticon').each(function () {
                                        $(this).html(`<i class="fa fa-arrows" aria-hidden="true"></i>`);
                                    });
                                    $(elementClone).css('transform', 'translate3d(0px, ' + ((indexFirst + index) * 30) + 'px, 0px)');
                                    $(el).css('transform', 'translate3d(0px, ' + ((indexFirst + index) * 30) + 'px, 0px)');
                                    $(el).css('z-index', '10');
                                    $(el).css('background-color', '#f9f9f9');
                                }
                            }
                        });
                    }
                });
            }
            this.checkModel();

            this.dragulaService.createGroup(this.dragulaName, {
                moves: (el, container, handle) => {
                    return handle.tagName === 'I' || handle.className === 'selecticon';
                },
                invalid: (el, handle) => {
                    return handle.tagName === 'I' || handle.className === 'selecticon';
                }
            });

            // this.dragulaService.add(this.dragulaName, this.drake);
        }

        // Set DRAG and DROP subscriptions and callbacks
        /*this.subscriptionDrag = this.subs.add(this.dragulaService.drag().subscribe(({ name, el, source }) => {
            const elem = $(el).find('.getID');
            this.drag(this.dragulaModel[$(elem).attr('id')]);

        })
        );
        this.subscriptionDrop = this.subs.add(this.dragulaService.drop(this.dragulaName).subscribe((value) => {
            // const [bagName, el, target, source] = value;
            const elem = $(value.el).find('.getID');

            let row;
            this.dragulaModel.forEach(elt => {
                if (elt.index === parseInt($(elem).attr('id'), 10)) {
                    row = elt;
                }
            });
            const old_index = this.dragulaModel.indexOf(row);
            this.move(this.dragulaModel, old_index, this.getIndexInParent(value.el));
            this.onDropModel(this.dragulaModel);
        })
        );*/
    }

    moveArrayItemToNewIndex(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            let k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    private checkModel() {
        console.log(this.dragulaModel)
        if (this.dragulaModel) {
            if (this.drake.models) {
                this.drake.models.push(this.dragulaModel);
            } else {
                this.drake.models = [this.dragulaModel];
            }

            console.log(this.drake.models)
        }
    }

    drop(el, target, isShadow?) {
        const elem = $(el).find('.getID');
        let idLigne = 0;
        if (this.dragulaModel && this.elementTodrag) {
            this.elementTodrag.dragstart = true;
            idLigne = this.elementTodrag.id;
        }
        let liste = [];
        let startList = [];
        let lastList = [];
        const middleList = [];
        const source = $(target).find('datatable-row-wrapper');
        const listeDragModel = [...this.dragulaModel]
        const ctrl = this;
        console.log('this.drake.models', this.drake.models)
        let firstId = '0';
        let lastId = '0';
        $(source).each(function (index) {
            const elt = $(this).find('.getID');
            if (!index) {
                firstId = $(elt).attr('id');
            }
            const existeLigne = middleList.filter(l => {
                const ligne = !ctrl.dragulaModel[$(elt).attr('id')] ? ctrl.elementTodrag : ctrl.dragulaModel[$(elt).attr('id')]
                return l && l.id === ligne.id
            });
            if (!existeLigne || (existeLigne && !existeLigne.length)) {
                middleList.push(!ctrl.dragulaModel[$(elt).attr('id')] ? ctrl.elementTodrag : ctrl.dragulaModel[$(elt).attr('id')]);
            }


            lastId = $(elt).attr('id');
        });

        if (middleList.length < this.dragulaModel.length) {
            startList = this.dragulaModel.filter((element, idx) => {
                const existe = middleList.filter(l => l && l.id === element.id);
                return idx < parseInt(firstId, 10) &&
                    element.id !== idLigne && (!existe || (existe && !existe.length))
            });
            lastList = this.dragulaModel.filter((element, idx) => {
                const existe = middleList.filter(l => l && l.id === element.id);
                return idx > parseInt(lastId, 10)
                    && element.id !== idLigne && (!existe || (existe && !existe.length));
            });
        }

        console.log('startList', startList)
        console.log('middleList', middleList)
        console.log('lastList', lastList)
        console.log('idLigne', idLigne)

        liste = [...startList, ...middleList, ...lastList];

        const index = liste.indexOf(this.elementTodrag);

        if (this.selectedrag) {
            this.selectedrag = this.selectedrag.filter(elt => elt.id !== this.elementTodrag.id);
            this.selectedrag.forEach(elt => liste = liste.filter(element => element.id !== elt.id));
            this.selectedrag.forEach(elt => liste.splice(index + 1, 0, elt));
        }

        console.log(liste);
        if (!isShadow) {
            this.onDropModel(liste);
        }
    }

    private drag(elt) {
        this.directiveDrag.emit(elt);
    }

    private onDropModel(args?) {
        // let [el, target, source] = args;
        // Added emitter on any DROP action

        this.directiveDrop.emit(args);
    }
    getIndexInParent(el) {
        return Array.from(el.parentNode.children).indexOf(el);
    }

    public ngOnChanges(changes: { dragulaModel?: SimpleChange }): void {

        // Must update model on any changes
        // Otherwise it will fall out of sync with the 'dragulaModel'
        if (changes && changes.dragulaModel) {
            if (this.drake) {
                if (this.drake.models) {
                    const modelIndex = this.drake.models.indexOf(changes.dragulaModel.previousValue);
                    this.drake.models.splice(modelIndex, 1, changes.dragulaModel.currentValue);
                } else {
                    this.drake.models = [changes.dragulaModel.currentValue];
                }
            }
        }
    }

    array_move(arr, old_index, new_index) {
        while (old_index < 0) {
            old_index += arr.length;
        }
        while (new_index < 0) {
            new_index += arr.length;
        }
        if (new_index >= arr.length) {
            let k = new_index - arr.length;
            while ((k--) + 1) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, -1, arr.splice(old_index, 1)[0]);
        return arr;
    }

    move(arr, from, to) {
        const element = arr[from];
        arr.splice(from, 1);
        arr.splice(to, 0, element);
    }

    moveElementInArray(array, value, positionChange) {
        const oldIndex = array.indexOf(value);
        if (oldIndex > -1) {
            let newIndex = (oldIndex + positionChange);

            if (newIndex < 0) {
                newIndex = 0;
            } else if (newIndex >= array.length) {
                newIndex = array.length;
            }

            const arrayClone = array.slice();
            arrayClone.splice(oldIndex, 1);
            arrayClone.splice(newIndex, 0, value);

            return arrayClone;
        }
        return array;
    }
}
